/* eslint-disable */
import { ProductMeta, Rating, Rating_SkuInfo } from "../../common/common";

export const protobufPackage = "store.api.orders";

export interface ListRatingsRequest {
  /** Optional. If given, then list ratings for this product only; otherwise, list all ratings. */
  productId: string;
  /**
   * Optional. Maximum 1000.
   * Only valid when `page_token` is not-empty because the first page will always return the
   * predefined rating cache size.
   */
  pageSize: number;
  /** Optional. */
  pageToken: string;
}

export interface ListRatingsResponse {
  /** Order by `create_time` DESC, `id` ASC. */
  ratings: Rating[];
  /** Key is sku id. */
  skuInfos: { [key: string]: Rating_SkuInfo };
  /** Key is product id. */
  productMetas: { [key: string]: ProductMeta };
  nextPageToken: string;
  /** 全部總數. Only valid when `page_token` is empty. */
  allCount: number;
}

export interface ListRatingsResponse_SkuInfosEntry {
  key: string;
  value: Rating_SkuInfo | undefined;
}

export interface ListRatingsResponse_ProductMetasEntry {
  key: string;
  value: ProductMeta | undefined;
}

export interface GetOrderRatingsRequest {
  /** Required. */
  orderId: string;
}

export interface GetOrderRatingsResponse {
  /** Key is order item id. */
  ratings: { [key: string]: Rating };
}

export interface GetOrderRatingsResponse_RatingsEntry {
  key: string;
  value: Rating | undefined;
}

export interface CreateOrderRatingsRequest {
  /** Key is order item id. */
  ratings: { [key: string]: Rating };
}

export interface CreateOrderRatingsRequest_RatingsEntry {
  key: string;
  value: Rating | undefined;
}

function createBaseListRatingsRequest(): ListRatingsRequest {
  return { productId: "", pageSize: 0, pageToken: "" };
}

export const ListRatingsRequest = {
  fromJSON(object: any): ListRatingsRequest {
    return {
      productId: isSet(object.productId) ? String(object.productId) : "",
      pageSize: isSet(object.pageSize) ? Number(object.pageSize) : 0,
      pageToken: isSet(object.pageToken) ? String(object.pageToken) : "",
    };
  },

  toJSON(message: ListRatingsRequest): unknown {
    const obj: any = {};
    message.productId !== undefined && (obj.productId = message.productId);
    message.pageSize !== undefined && (obj.pageSize = Math.round(message.pageSize));
    message.pageToken !== undefined && (obj.pageToken = message.pageToken);
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRatingsRequest>, I>>(base?: I): ListRatingsRequest {
    return ListRatingsRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListRatingsRequest>, I>>(object: I): ListRatingsRequest {
    const message = createBaseListRatingsRequest();
    message.productId = object.productId ?? "";
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    return message;
  },
};

function createBaseListRatingsResponse(): ListRatingsResponse {
  return { ratings: [], skuInfos: {}, productMetas: {}, nextPageToken: "", allCount: 0 };
}

export const ListRatingsResponse = {
  fromJSON(object: any): ListRatingsResponse {
    return {
      ratings: Array.isArray(object?.ratings) ? object.ratings.map((e: any) => Rating.fromJSON(e)) : [],
      skuInfos: isObject(object.skuInfos)
        ? Object.entries(object.skuInfos).reduce<{ [key: string]: Rating_SkuInfo }>((acc, [key, value]) => {
          acc[key] = Rating_SkuInfo.fromJSON(value);
          return acc;
        }, {})
        : {},
      productMetas: isObject(object.productMetas)
        ? Object.entries(object.productMetas).reduce<{ [key: string]: ProductMeta }>((acc, [key, value]) => {
          acc[key] = ProductMeta.fromJSON(value);
          return acc;
        }, {})
        : {},
      nextPageToken: isSet(object.nextPageToken) ? String(object.nextPageToken) : "",
      allCount: isSet(object.allCount) ? Number(object.allCount) : 0,
    };
  },

  toJSON(message: ListRatingsResponse): unknown {
    const obj: any = {};
    if (message.ratings) {
      obj.ratings = message.ratings.map((e) => e ? Rating.toJSON(e) : undefined);
    } else {
      obj.ratings = [];
    }
    obj.skuInfos = {};
    if (message.skuInfos) {
      Object.entries(message.skuInfos).forEach(([k, v]) => {
        obj.skuInfos[k] = Rating_SkuInfo.toJSON(v);
      });
    }
    obj.productMetas = {};
    if (message.productMetas) {
      Object.entries(message.productMetas).forEach(([k, v]) => {
        obj.productMetas[k] = ProductMeta.toJSON(v);
      });
    }
    message.nextPageToken !== undefined && (obj.nextPageToken = message.nextPageToken);
    message.allCount !== undefined && (obj.allCount = Math.round(message.allCount));
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRatingsResponse>, I>>(base?: I): ListRatingsResponse {
    return ListRatingsResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListRatingsResponse>, I>>(object: I): ListRatingsResponse {
    const message = createBaseListRatingsResponse();
    message.ratings = object.ratings?.map((e) => Rating.fromPartial(e)) || [];
    message.skuInfos = Object.entries(object.skuInfos ?? {}).reduce<{ [key: string]: Rating_SkuInfo }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = Rating_SkuInfo.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.productMetas = Object.entries(object.productMetas ?? {}).reduce<{ [key: string]: ProductMeta }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = ProductMeta.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.nextPageToken = object.nextPageToken ?? "";
    message.allCount = object.allCount ?? 0;
    return message;
  },
};

function createBaseListRatingsResponse_SkuInfosEntry(): ListRatingsResponse_SkuInfosEntry {
  return { key: "", value: undefined };
}

export const ListRatingsResponse_SkuInfosEntry = {
  fromJSON(object: any): ListRatingsResponse_SkuInfosEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? Rating_SkuInfo.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ListRatingsResponse_SkuInfosEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value ? Rating_SkuInfo.toJSON(message.value) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRatingsResponse_SkuInfosEntry>, I>>(
    base?: I,
  ): ListRatingsResponse_SkuInfosEntry {
    return ListRatingsResponse_SkuInfosEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListRatingsResponse_SkuInfosEntry>, I>>(
    object: I,
  ): ListRatingsResponse_SkuInfosEntry {
    const message = createBaseListRatingsResponse_SkuInfosEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? Rating_SkuInfo.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseListRatingsResponse_ProductMetasEntry(): ListRatingsResponse_ProductMetasEntry {
  return { key: "", value: undefined };
}

export const ListRatingsResponse_ProductMetasEntry = {
  fromJSON(object: any): ListRatingsResponse_ProductMetasEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? ProductMeta.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ListRatingsResponse_ProductMetasEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value ? ProductMeta.toJSON(message.value) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRatingsResponse_ProductMetasEntry>, I>>(
    base?: I,
  ): ListRatingsResponse_ProductMetasEntry {
    return ListRatingsResponse_ProductMetasEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListRatingsResponse_ProductMetasEntry>, I>>(
    object: I,
  ): ListRatingsResponse_ProductMetasEntry {
    const message = createBaseListRatingsResponse_ProductMetasEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? ProductMeta.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseGetOrderRatingsRequest(): GetOrderRatingsRequest {
  return { orderId: "" };
}

export const GetOrderRatingsRequest = {
  fromJSON(object: any): GetOrderRatingsRequest {
    return { orderId: isSet(object.orderId) ? String(object.orderId) : "" };
  },

  toJSON(message: GetOrderRatingsRequest): unknown {
    const obj: any = {};
    message.orderId !== undefined && (obj.orderId = message.orderId);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderRatingsRequest>, I>>(base?: I): GetOrderRatingsRequest {
    return GetOrderRatingsRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOrderRatingsRequest>, I>>(object: I): GetOrderRatingsRequest {
    const message = createBaseGetOrderRatingsRequest();
    message.orderId = object.orderId ?? "";
    return message;
  },
};

function createBaseGetOrderRatingsResponse(): GetOrderRatingsResponse {
  return { ratings: {} };
}

export const GetOrderRatingsResponse = {
  fromJSON(object: any): GetOrderRatingsResponse {
    return {
      ratings: isObject(object.ratings)
        ? Object.entries(object.ratings).reduce<{ [key: string]: Rating }>((acc, [key, value]) => {
          acc[key] = Rating.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: GetOrderRatingsResponse): unknown {
    const obj: any = {};
    obj.ratings = {};
    if (message.ratings) {
      Object.entries(message.ratings).forEach(([k, v]) => {
        obj.ratings[k] = Rating.toJSON(v);
      });
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderRatingsResponse>, I>>(base?: I): GetOrderRatingsResponse {
    return GetOrderRatingsResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOrderRatingsResponse>, I>>(object: I): GetOrderRatingsResponse {
    const message = createBaseGetOrderRatingsResponse();
    message.ratings = Object.entries(object.ratings ?? {}).reduce<{ [key: string]: Rating }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = Rating.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseGetOrderRatingsResponse_RatingsEntry(): GetOrderRatingsResponse_RatingsEntry {
  return { key: "", value: undefined };
}

export const GetOrderRatingsResponse_RatingsEntry = {
  fromJSON(object: any): GetOrderRatingsResponse_RatingsEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? Rating.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: GetOrderRatingsResponse_RatingsEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value ? Rating.toJSON(message.value) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderRatingsResponse_RatingsEntry>, I>>(
    base?: I,
  ): GetOrderRatingsResponse_RatingsEntry {
    return GetOrderRatingsResponse_RatingsEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOrderRatingsResponse_RatingsEntry>, I>>(
    object: I,
  ): GetOrderRatingsResponse_RatingsEntry {
    const message = createBaseGetOrderRatingsResponse_RatingsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? Rating.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseCreateOrderRatingsRequest(): CreateOrderRatingsRequest {
  return { ratings: {} };
}

export const CreateOrderRatingsRequest = {
  fromJSON(object: any): CreateOrderRatingsRequest {
    return {
      ratings: isObject(object.ratings)
        ? Object.entries(object.ratings).reduce<{ [key: string]: Rating }>((acc, [key, value]) => {
          acc[key] = Rating.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: CreateOrderRatingsRequest): unknown {
    const obj: any = {};
    obj.ratings = {};
    if (message.ratings) {
      Object.entries(message.ratings).forEach(([k, v]) => {
        obj.ratings[k] = Rating.toJSON(v);
      });
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrderRatingsRequest>, I>>(base?: I): CreateOrderRatingsRequest {
    return CreateOrderRatingsRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CreateOrderRatingsRequest>, I>>(object: I): CreateOrderRatingsRequest {
    const message = createBaseCreateOrderRatingsRequest();
    message.ratings = Object.entries(object.ratings ?? {}).reduce<{ [key: string]: Rating }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = Rating.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseCreateOrderRatingsRequest_RatingsEntry(): CreateOrderRatingsRequest_RatingsEntry {
  return { key: "", value: undefined };
}

export const CreateOrderRatingsRequest_RatingsEntry = {
  fromJSON(object: any): CreateOrderRatingsRequest_RatingsEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? Rating.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: CreateOrderRatingsRequest_RatingsEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value ? Rating.toJSON(message.value) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrderRatingsRequest_RatingsEntry>, I>>(
    base?: I,
  ): CreateOrderRatingsRequest_RatingsEntry {
    return CreateOrderRatingsRequest_RatingsEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CreateOrderRatingsRequest_RatingsEntry>, I>>(
    object: I,
  ): CreateOrderRatingsRequest_RatingsEntry {
    const message = createBaseCreateOrderRatingsRequest_RatingsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? Rating.fromPartial(object.value)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
